import { Component, OnInit, Input, forwardRef, ViewChild, ElementRef, EventEmitter, Output, OnChanges, SimpleChanges, ChangeDetectorRef, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, of, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { DialogAgGridSearchComponent } from '../dialog-ag-grid-search/dialog-ag-grid-search.component';
import { SharedComponentsUtil } from '../utils/classes/SharedComponentsUtil';
import { ValidateUtil } from '../utils/classes/ValidateUtil';
import { MessageUtilService } from '../utils/service/message-util.service';
import { NgSelectSimpleService } from './ng-select-simple.service';

export class SearchParams {

  constructor(
    public columnDefs: ColumnDefs[] = [],
    public title: string = '',
    public width: string = '990px',
    public rowData: Observable<any[]> = of([])
  ) { }
}

export class ColumnDefs {
  headerName?: string;
  field?: string;
  width?: string;
  cellRenderer?: any;
  valueGetter?: (field: any) => string | string;
  sortable?: boolean;
  resizable?: boolean;
  cellClass?: string[];
  cellStyle?: {};
  valueFormatter?: any;
  pinned?: string;

}

@Component({
  selector: 'ng-select-simple',
  templateUrl: './ng-select-simple.component.html',
  styleUrls: ['./ng-select-simple.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgSelectSimpleComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NgSelectSimpleComponent),
      multi: true,
    }
  ],
  encapsulation: ViewEncapsulation.None
})

@AutoUnsubscribe()
export class NgSelectSimpleComponent implements OnInit, OnChanges, OnDestroy {


  @ViewChild('ngSelectSimple') ngSelectSimple!: NgSelectComponent;
  @ViewChild('btnSearch') btnSearch!: ElementRef;

  @Input() showLabel:boolean = true;
  @Input() label: any = null;
  @Input() autocomplete: string = "cc-csc";
  @Input() next: any;
  @Input() nextIsDisable: any;
  @Input() back: any;
  @Input() backIsDisable: any;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() validatorMessage: boolean = false;
  @Input() tooltipMessage: boolean = true;
  @Input() openWhenFocus: boolean = false;
  @Input() searchBy: string = "value";
  @Input() markFirstItem: boolean = false;
  @Input() markWhenHaveOneItem: boolean = false;
  @Input() submitted: boolean = true;
  @Input() setNgClass: string = "";
  @Input() searchable: boolean = true;
  @Input() validatorAlert: boolean = false;
  @Input() upperCase: boolean = false;

  @Input() appendTo: string = "body";
  @Input() items!: Observable<any[]>;

  @Input() loading: boolean = true;
  @Input() loadingText: string = "Cargando...";
  @Input() clearAllText: string = "Limpiar";


  @Input() markFirst: boolean = true;
  @Input() clearable: boolean = true;
  @Input() clearOnBackspace: boolean = false;
  @Input() virtualScroll: boolean = true;
  @Input() openOnEnter: boolean = false;
  @Input() refresh: boolean = false;
  @Input() search: boolean = false;
  @Input() searchParams: SearchParams = new SearchParams();

  @Output() onNext: EventEmitter<any> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() onfocus: EventEmitter<any> = new EventEmitter();
  @Output() onrefresh: EventEmitter<any> = new EventEmitter();
  validateUtil = new ValidateUtil();
  sharedComponentsUtil = new SharedComponentsUtil();


  allItems = [];
  _value: any;
  controls: any;

  private items$!: Subscription;

  onChange = (_: any) => { };

  onValidationChange = () => { };

  onTouched = () => { };


  focus = () => {
    this.ngSelectSimple.focus();
    if (this.openWhenFocus) {
      this.ngSelectSimple.open();
    }

  }

  close = () => {
    this.ngSelectSimple.close();
  }

  constructor(
    private messageUtilService: MessageUtilService,
    public dialog: MatDialog,
    private ngSelectSimpleService: NgSelectSimpleService
  ) {
      this.validatorMessage = this.ngSelectSimpleService.getValidatorMessage();
      this.tooltipMessage = this.ngSelectSimpleService.getTooltipMessage(); 
      this.openWhenFocus = this.ngSelectSimpleService.getOpenWhenFocus(); 
      this.searchBy = this.ngSelectSimpleService.getSearchBy(); 
      this.markFirstItem = this.ngSelectSimpleService.getMarkFirstItem(); 
      this.submitted = this.ngSelectSimpleService.getSubmitted(); 
      this.searchable = this.ngSelectSimpleService.getSearchable(); 
      this.validatorAlert = this.ngSelectSimpleService.getValidatorAlert(); 
      this.upperCase = this.ngSelectSimpleService.getUpperCase(); 
      this.appendTo = this.ngSelectSimpleService.getAppendTo(); 
      this.loadingText = this.ngSelectSimpleService.getLoadingText(); 
      this.clearAllText = this.ngSelectSimpleService.getClearAllText(); 
      this.markFirst = this.ngSelectSimpleService.getMarkFirst(); 
      this.clearable = this.ngSelectSimpleService.getClearable();
      this.clearOnBackspace = this.ngSelectSimpleService.getClearOnBackspace(); 
      this.virtualScroll = this.ngSelectSimpleService.getVirtualScroll();
      this.openOnEnter = this.ngSelectSimpleService.getOpenOnEnter(); 
   }

  ngOnDestroy(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.loading = true;
      this.carga();
    }
    if (changes.submitted) {
      if (this.controls !== undefined && changes.submitted.currentValue) {
        this.controls.markAsDirty();
        this.controls.markAsTouched();
      }
    }
  }

  async carga() {
    this.allItems = await new Promise((resolve, reject) => {
      this.items = this.items.pipe(shareReplay({refCount: true}));
      this.items$ = this.items.subscribe((res:any) => {
        resolve(res); 
      });
    });
    this.loading = false;
    if (this._value != null) {
      this.allItems.forEach(element => {
        if ((!this.validateUtil.isUndefinedOrNull(this.getObject(element, this.searchBy))) && this.getObject(element, this.searchBy) === this._value) {
          this._value = element;
          this.onChange(this._value);
          this.onValidationChange();
          this.change.emit(this._value);
        }
      });

    } else {
      if (this.markFirstItem && this.allItems.length > 0) {
        this._value = this.allItems[0];
        this.onChange(this._value);
        this.onValidationChange();
        this.change.emit(this._value);
      }
      if (this.markWhenHaveOneItem && this.allItems.length === 1) {
        this._value = this.allItems[0];
        this.onChange(this._value);
        this.onValidationChange();
        this.change.emit(this._value);
      }

    }
  }



  ngOnInit() {
  }

  getObject(obj:any, key:any) {
    return key.split(".").reduce(function (o:any, x:any) {
      return (typeof o == "undefined" || o === null) ? o : o[x];
    }, obj);
  }

  writeValue(value: any): void {
    if (value != null) {
      if (this.loading) {
        this._value = value;
      } else {
        this._value = value;
        this.allItems.forEach(element => {
          if ((!this.validateUtil.isUndefinedOrNull(this.getObject(element, this.searchBy))) && this.getObject(element, this.searchBy) === this._value) {
            this._value = element;
            this.onChange(this._value);
            this.onValidationChange();
            this.change.emit(this._value);
          }
        });
      }

      //this.searchElement(value);
      this.onValidationChange();
    } else {
      this._value = null;
      this.onValidationChange();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | any {
    this.controls = control;
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  eventChange(e : any) {
    this.onChange(e);
    this.onValidationChange();
    this.change.emit(e);
  }

  eventBlur(e : any) {
    this.onTouched();
    this.onValidationChange();
    this.blur.emit(e);

  }

  eventFocus(e : any) {
    // this.ngSelectSimple.focus();
    if (this.openWhenFocus) {
      this.ngSelectSimple.open();
    }
    this.onfocus.emit(e);
  }

  enterKeyUp() {
    this.ngSelectSimple.close();
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(this.controls, this.validatorAlert, this.label);
      if (validator.error) {
        this.messageUtilService.getMessageError("000046", "Error", validator.message);
        return;
      }
    }
    if (this.next != undefined) {
      if (this.next.disabled || this.next.readonly) {
        if (this.nextIsDisable != undefined) {
          this.nextIsDisable.focus();
        }
      } else {
        this.next.focus();
      }
    } else {
      if (this.nextIsDisable != undefined) {
        this.nextIsDisable.focus();
      } else {
        this.onNext.emit();
      }
    }
  }

  leftKeyUp() {
    this.ngSelectSimple.close();
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(this.controls, this.validatorAlert, this.label);
      if (validator.error) {
        this.messageUtilService.getMessageError("000046", "Error", validator.message);
        return;
      }
    }
    if (this.back != undefined) {
      if (this.back.disabled || this.back.readonly) {
        if (this.backIsDisable != undefined) {
          this.backIsDisable.focus();
        }
      } else {
        this.back.focus();
      }
    } else {
      if (this.backIsDisable != undefined) {
        this.backIsDisable.focus();
      } else {
        this.onBack.emit();
      }
    }
  }

  clear() {
    this._value = null;
    this.onChange(this._value);
    this.onValidationChange();
    this.change.emit(this._value);
  }

  onRefresh() {
    this.onrefresh.emit();
  }

  async onSearch() {
    const dialogRef = this.dialog.open(DialogAgGridSearchComponent, {
      width: this.searchParams.width,
      disableClose: true
    });
    let rowdata = await this.searchParams.rowData.toPromise()
    let instance = dialogRef.componentInstance;
    instance.tittle = this.searchParams.title === '' ? this.label : this.searchParams.title;
    instance.rowData = rowdata.length < 1 ? this.items : this.searchParams.rowData;
    instance.columnDefs = this.searchParams.columnDefs;
    dialogRef.afterClosed().subscribe((resp: any[]) => {
      this.focus();
      if (resp.length > 0) {
        this._value = resp[0];
        this.onChange(this._value);
        this.onValidationChange();
        this.change.emit(this._value);
      }
    });
  }

  f1KeyUp() {
    if (!this.btnSearch) {
      return;
    }
    this.ngSelectSimple.close();
    //this.btnSearch.nativeElement.focus();
    this.onSearch();
  }

}
